import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge only knows Tailwind's default scale. The design system adds
 * its own type sizes, density-aware control sizes, and shadows (see
 * src/index.css @theme); without registering them, `text-control` would be
 * mistaken for a text color and silently dropped next to `text-primary-foreground`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['caption', 'body', 'body-lg', 'title', 'heading', 'control'],
      spacing: ['control', 'control-sm', 'control-x', 'card'],
      shadow: ['card', 'overlay'],
    },
  },
})

/**
 * Merge class names, resolving Tailwind utility conflicts (the last conflicting
 * utility wins). Used by the shadcn-style UI primitives to compose a base class
 * set with caller-supplied overrides.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
